import React from "react";
import { Icon, type IconProps } from "@chakra-ui/react";

export function ErrorIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M8.575 3.216 1.516 15a1.666 1.666 0 0 0 1.425 2.5h14.117a1.667 1.667 0 0 0 1.425-2.5L11.425 3.216a1.667 1.667 0 0 0-2.85 0ZM10 7.5v3.333M10 14.167h.008"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
